import React from 'react'
import Portal from 'react-portal'
import MainNavSection from '../../components/Navigation/MainNavSection.js'
import { Manager, Target } from 'react-popper'
import { UserProfilePopover } from '../../views/Popovers'

const ShowUserProfileButton = () => (
	<Manager tag={'span'}>
		<Portal
			closeOnEsc
			openByClickOn={
				<Target>
					<MainNavSection icon="account_circle" label="My Profile" />
				</Target>
			}
			closeOnOutsideClick={true}
		>
			<UserProfilePopover />
		</Portal>
	</Manager>
)

export default ShowUserProfileButton



// WEBPACK FOOTER //
// ./src/containers/Buttons/ShowUserProfileButton.js